import { Injectable } from '@angular/core';
import { ItineraryResponseModel } from '@app/core/models/itinerary.model';
import { LoggingService } from '@app/core/services/logging/logging.service';
import { TranslocoService } from '@jsverse/transloco';
import { trackRequestResult } from '@ngneat/elf-requests';
import { Observable, from, switchMap, tap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { environment } from 'src/environments/environment';
import { FirebaseAuthenticationService } from '../firebase';

/**
 * Service responsible for handling Gemini-related functionality.
 */
@Injectable()
export class AgentService {
  constructor(
    private _translocoService: TranslocoService,
    private authService: FirebaseAuthenticationService,
  ) {}

  /**
   * Retrieves the itinerary for a property.
   * @param propertyId - The ID of the property to retrieve itinerary for.
   * @param bookingId - The ID of the booking to retrieve itinerary for.
   * @param newRecommendation - Whether to retrieve a new recommendation.
   * @returns An Observable that emits an array of itinerary.
   */
  getItinerary(
    propertyId: string,
    bookingId: string,
    newRecommendation: boolean = false,
  ): Observable<ItineraryResponseModel> {
    const currentLang = this._translocoService.getActiveLang();
    return from(this.authService.getIdToken({ forceRefresh: false })).pipe(
      switchMap(data => {
        // Use the Headers constructor correctly and include the token
        const headers = new Headers({
          Authorization: `Bearer ${data.token}`,
          'Accept-Language': currentLang,
          'Content-Type': 'application/json',
        });
        return fromFetch<ItineraryResponseModel>(
          `${environment.api.serverUrl}/agent/recommendation/property/${propertyId}?bookingId=${bookingId}&newRecommendation=${newRecommendation}`,
          {
            selector: response => response.json(),
            headers: headers,
          },
        ).pipe(
          tap(reccomendations => {
            LoggingService.log(reccomendations);
          }),
          trackRequestResult(['itinerary'], { skipCache: true }),
        );
      }),
    );
  }
}
